import { filters, Sprite } from 'pixi.js';

export class Ripple {
    constructor(x, y, stage) {
        // sprite
        // https://i.imgur.com/kr2RVKW.png
        // http://i.imgur.com/MfPhT1Y.png
        this.sprite = Sprite.from("displacement");
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(x, y);
        this.sprite.scale.set(0);
        stage.addChild(this.sprite);
        this.filter = new filters.DisplacementFilter(this.sprite);
      }

      update(dt) {
          if (!this.sprite || !this.sprite.transform) return;
          this.sprite.scale.x += dt * 0.01;
          this.sprite.scale.y += dt * 0.01;

          if (this.sprite.scale.x > 3){
            this.sprite.scale.x = 0;
            this.sprite.scale.y = 0;
          }
      }
}
